import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList } from "vue";
const _hoisted_1 = { class: "opModal" };
const _hoisted_2 = {
    key: 0,
    class: "text-center py-2 d-flex align-items-center justify-content-center"
};
const _hoisted_3 = { class: "mx-4 fs-22 max-w300" };
const _hoisted_4 = { class: "closer" };
const _hoisted_5 = {
    class: "swiper-container gallerySwiper",
    ref: "swiper"
};
const _hoisted_6 = { class: "swiper-wrapper" };
const _hoisted_7 = ["data"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.otherTaskList.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-green",
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.prevTask && _ctx.prevTask(...args)))
                }, "Task precedente"),
                _createElementVNode("span", _hoisted_3, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.otherTaskList[_ctx.taskIndex].title), 1),
                    (_ctx.otherTaskList[_ctx.taskIndex].userAssigned)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" - " + _toDisplayString(_ctx.otherTaskList[_ctx.taskIndex].userAssigned.name), 1)
                        ], 64))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-green",
                    onClick: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => (_ctx.nextTask && _ctx.nextTask(...args)))
                }, "Task successivo")
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
                type: "button",
                class: "btn btn-danger",
                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('close')))
            }, _cache[5] || (_cache[5] = [
                _createElementVNode("i", { class: "fas fa-times" }, null, -1)
            ]))
        ]),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
                class: "swipeLeft pointer",
                onClick: _cache[3] || (_cache[3] =
                    //@ts-ignore
                    (...args) => (_ctx.prevSlide && _ctx.prevSlide(...args)))
            }, _cache[6] || (_cache[6] = [
                _createElementVNode("i", { class: "fas fa-chevron-left" }, null, -1)
            ])),
            _createElementVNode("div", {
                class: "swipeRight pointer",
                onClick: _cache[4] || (_cache[4] =
                    //@ts-ignore
                    (...args) => (_ctx.nextSlide && _ctx.nextSlide(...args)))
            }, _cache[7] || (_cache[7] = [
                _createElementVNode("i", { class: "fas fa-chevron-right" }, null, -1)
            ])),
            _createElementVNode("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.finalImages, (item, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "swiper-slide",
                        key: item.fileIdentifier
                    }, [
                        _createElementVNode("object", {
                            class: "imgContainer",
                            data: item.publicUrl
                        }, null, 8, _hoisted_7)
                    ]));
                }), 128))
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "swiper-pagination" }, null, -1))
        ], 512)
    ]));
}
